import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import {
  ErrorBoundary as EB,
  getErrorMessage,
  type FallbackProps,
} from 'react-error-boundary';
import Layout from '@/components/Layout';
import Heading from '@/components/Heading/Heading';
import PageShell from '@/components/PageShell';
import miaLogo from '@/assets/images/mia-logo-dark.svg';
import { miaConsoleLog } from '@/utils/mia-logger';

// Error + retry
export const ErrorView = ({ error, resetErrorBoundary }: FallbackProps) => {
  return (
    <Layout>
      <PageShell variant='single'>
        <Heading level={1} align='center'>
          <img src={miaLogo} alt='Mia' className='inline-block' />
        </Heading>
        <div>
          <p className='text-red-500'>Error: {getErrorMessage(error)}</p>
          <button onClick={resetErrorBoundary}>Retry</button>
        </div>
      </PageShell>
    </Layout>
  );
};

// Combine and render children if all OK.
const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const { reset } = useQueryErrorResetBoundary();
  return (
    <EB
      onReset={reset}
      FallbackComponent={ErrorView}
      onError={(error, info) => {
        console.log(error, info);
        miaConsoleLog('error', { message: 'Unhandled React error', error: String(error), componentStack: String(info?.componentStack ?? '') });
      }}
    >
      {children}
    </EB>
  );
};

export default ErrorBoundary;
